export const Tooltip = ({ children }) => {
  return (
    <span className="tooltip">
      {children}
    </span>
  )
}
